import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
`;

export const Container = styled.div`
  width: 100%;
  animation: ${fadeIn} 0.5s ease-out;
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
  padding: 25px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
`;

export const HeaderControl = styled.div`
  display: flex;
  justify-content: start; /* Alinha a busca à direita */
  margin-bottom: 20px;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 768px) {
    justify-content: stretch;
  }
`;

export const SearchBar = styled.div`
  position: relative;
  width: 100%;
  max-width: 350px;
  box-sizing: border-box;

  input {
    width: 100%;
    padding: 12px 15px 12px 45px; /* Espaço para o ícone */
    border: 1px solid #e5e7eb;
    border-radius: 10px;
    font-size: 14px;
    color: #374151;
    outline: none;
    transition: all 0.2s ease;
    background-color: #f9fafb;
    box-sizing: border-box;
    height: 45px;

    &::placeholder {
      color: #9ca3af;
    }

    &:focus {
      border-color: #d4af37;
      background-color: #fff;
      box-shadow: 0 0 0 3px rgba(212, 175, 55, 0.1);
    }
  }

  svg {
    position: absolute;
    left: 15px;
    top: 50%;
    transform: translateY(-50%);
    color: #9ca3af;
    pointer-events: none;
    font-size: 16px;
  }
`;

export const TableContainer = styled.div`
  overflow-x: auto;
  width: 100%;
  box-sizing: border-box;
  border-radius: 8px;
  border: 1px solid #f3f4f6;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  min-width: 700px; /* Garante que não quebre em mobile */

  thead {
    background-color: #f9fafb;
    tr {
      border-bottom: 2px solid #e5e7eb;
      th {
        text-align: left;
        padding: 18px 20px;
        color: #4b5563;
        font-weight: 700;
        font-size: 12px;
        text-transform: uppercase;
        letter-spacing: 0.05em;
      }
    }
  }

  tbody {
  
    tr {
      border-bottom: 1px solid #f3f4f6;
      transition: all 0.2s ease;
      cursor: pointer;
      box-sizing: border-box;

      &:last-child {
        border-bottom: none;
      }

      &:hover {
        background: #fffbf0; /* Amarelo bem claro */
        // transform: scale(1.01); 
      }

      td {
        padding: 18px 20px;
        color: #111827;
        font-size: 14px;
        font-weight: 500;
        vertical-align: middle;

        &.id-col {
          color: #6b7280;
          font-family: monospace;
          font-weight: 600;
        }

        &.desc {
          font-weight: 600;
          color: #1f2937;
          max-width: 300px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        &.date {
          color: #4b5563;
        }

        &.box-id {
          color: #d4af37;
          font-weight: 700;
        }
      }
    }
  }
`;

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 25px;
  gap: 12px;
  padding-top: 15px;
  border-top: 1px solid #f3f4f6;

  span {
    font-size: 14px;
    color: #6b7280;
    margin-right: 5px;
  }
`;

export const PageButton = styled.button`
  background: white;
  border: 1px solid #e5e7eb;
  padding: 8px 16px;
  border-radius: 8px;
  cursor: pointer;
  color: #374151;
  font-weight: 600;
  font-size: 13px;
  transition: all 0.2s;

  &:hover:not(:disabled) {
    border-color: #d4af37;
    color: #d4af37;
    background-color: #fffbf0;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background: #f9fafb;
  }
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 60px 20px;
  color: #9ca3af;
  font-size: 16px;
  background: #f9fafb;
  border-radius: 10px;
  border: 1px dashed #e5e7eb;
`;
